module.exports = "https://s3-ap-southeast-2.amazonaws.com/slik-fonts/ufc0001/img/opponent-paul-felder-3.eb70405f.png";